import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import md5 from 'md5';
import Moment from 'moment';
import Moment_Timezone from 'moment-timezone';
import Config from 'root/config';
import Cache from 'root/cache';
import Constants from 'root/constants';

var Util = {
    windowParent: function() {
        try {
            if (typeof window.parent.document == 'undefined') {
                return window;
            }

            return window.parent;
        } catch (exception) {
            return window;
        }
    },

    copyTextFallback(text, callback) {
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');

            if (callback) {
                callback();
            }
        } catch (err) {
        }

        document.body.removeChild(textArea);
    },

    copyText: function(text, callback) {
        if (!navigator.clipboard) {
            this.copyTextFallback(text, callback);
            return;
        }

        navigator.clipboard.writeText(text).then(function() {
            if (callback) {
                callback();
            }
        }, function(err) {
        });
    },

    removeEmoji: function(str) {
        return str.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
    },

    htmlEntities: function(str, nl2br) {
        if (str === undefined || str === null) {
            return '';
        }

        var text = String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

        if (nl2br) {
            text = text.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }

        return text;
    },

    htmlEntitiesWithA: function(str, nl2br, open_in_new_tab) {
        if (open_in_new_tab === undefined) {
            open_in_new_tab = true;
        }

        var text = String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        text = text.replace(/[\[]{1}([^\]]+)[\]]{1}[\(]{1}([^\)\"]+)(\"(.+)\")?[\)]{1}/g, '<a href="$2" title="$4" rel="noreferrer"' + (open_in_new_tab ? ' target="_blank"' : '') + '>$1</a>');

        if (nl2br) {
            text = text.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }

        return text;
    },

    matchDomain: function(domain, pattern) {
        if (pattern.indexOf('*') === -1) {
            return domain.replace(/\/$/, '') === pattern.replace(/\/$/, '');
        } else {
            pattern = pattern.replace('*', '.*?');
            pattern = pattern.replace('/', '\\/');
            const regex = new RegExp('^' + pattern + '$');
            return regex.test(domain);
        }
    },

    sanitizeCustomSubdomain: function(subdomain) {
        if (typeof subdomain !== 'string') {
            subdomain = String(subdomain);
        }

        return subdomain.replace(/[^a-zA-Z0-9-]/g, '').replace(/[-]{2,}/g, '-').toLowerCase();
    },

    sanitizeContenteditable: function(str) {
        str = str.replace(/<div>/gi, '');
        str = str.replace(/<p>/gi, '');
        str = str.replace(/<\/div>/gi, '\n');
        str = str.replace(/<\/p>/gi, '\n');
        str = str.replace(/<br\/?>/ig, '\n');
        str = str.replace(/(<([^>]+)>)/gi, '');
        str = str.replace(/&nbsp;/gi, ' ');
        str = str.replace(/&lt;/gi, '<');
        str = str.replace(/&gt;/gi, '>');
        str = str.replace(/&amp;/gi, '&');
        str = str.replace(/&quot;/gi, '"');
        str = str.replace(/[\n]{3,}/gi, '\n\n');

        return str;
    },

    nl2br: function(text) {
        return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
    },

    jsonHighlight: function(json) {
        try {
            if (typeof json != 'string') {
                json = JSON.stringify(json, null, 4);
            } else {
                json = JSON.stringify(JSON.parse(json), null, 4);
            }
        } catch (e) {
        }

        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }

            return '<span class="json-highlight-' + cls + '">' + match + '</span>';
        });
    },

    isUrl: function(text) {
        return text.match(/(((https?:\/\/)|(www\.))[^ ><\r\n]+)/g);
    },

    urlify: function(text) {
        return text.replace(/(((https?:\/\/)|(www\.))[^ ><\r\n]+)/g, function (url) {
            var link = url;
            var display;

            if (!link.match('^https?:\/\/')) {
                link = 'http://' + link;
            }

            if (link.charAt(link.length - 1) === '.') {
                display = url.slice(0, -1);
            } else {
                display = url;
            }

            // comment attachments
            var regex = new RegExp('https://' + Cache.app.configs.cloudfront_host + '.*/attachment/', 'g');
            display = display.replace(regex, '');

            return '<a href="' + link + '" target="_blank" rel="noreferrer">' + display + '</a>';
        });
    },

    safeUrl: function(url) {
        var base_url = url.substring(0, url.lastIndexOf('/') + 1);
        var file_name = url.substring(url.lastIndexOf('/') + 1);

        // Encoding the file name
        let encoded_file_name = encodeURIComponent(file_name);

        // Concatenating them back into a full URL
        return base_url + encoded_file_name;
    },

    parseComment: function(comment) {
        return comment.replace(/@@:(-?[0-9]+):(@?[^@]+)@@/g, function(str, user_id, name) {
            var name;

            if (user_id == -1) {
                name = 'all';
            } else {
                name = Cache.user.get(user_id) ? Cache.user.get(user_id).escape('name') : Util.htmlEntities(name);
            }

            return '<span class="at-name" userid="' + user_id + '" contenteditable="false">@' + name + '</span>';
        });
    },

    cap: function(str) {
        return str.toString().charAt(0).toUpperCase() + str.toString().slice(1);
    },

    baseName: function(path) {
        var path_array = path.split('/');
        return path_array[path_array.length - 1];
    },

    fileExtension: function(path) {
        var base_name = this.baseName(path);
        var base_name_array = base_name.split('.');

        if (base_name_array.length >= 2) {
            return base_name_array[base_name_array.length - 1].toLowerCase();
        } else {
            return false;
        }
    },

    isImage: function(path) {
        var extension = this.fileExtension(path);

        if (extension === 'png' || extension === 'gif' || extension === 'jpg' || extension === 'jpeg' || extension === 'svg') {
            return true;
        } else {
            return false;
        }
    },

    isVideo: function(path) {
        var extension = this.fileExtension(path);

        if (extension === 'mp4' || extension === 'webm' || extension === 'mov') {
            return true;
        } else {
            return false;
        }
    },

    getFileIcon: function(file_path, fixed_width) {
        if (fixed_width === undefined) {
            fixed_width = true;
        }

        var extension = this.fileExtension(file_path);
        var icon;

        switch (extension) {
            case 'zip':
                icon = '<i class="far' + (fixed_width ? ' fa-fw' : '') + ' fa-file-archive"></i>';
                break;
            case 'pdf':
                icon = '<i class="far' + (fixed_width ? ' fa-fw' : '') + ' fa-file-pdf"></i>';
                break;
            case 'doc':
            case 'docx':
                icon = '<i class="far' + (fixed_width ? ' fa-fw' : '') + ' fa-file-word"></i>';
                break;
            case 'xls':
            case 'xlsx':
                icon = '<i class="far' + (fixed_width ? ' fa-fw' : '') + ' fa-file-excel"></i>';
                break;
            case 'ppt':
            case 'pptx':
                icon = '<i class="far' + (fixed_width ? ' fa-fw' : '') + ' fa-file-powerpoint"></i>';
                break;
            case 'txt':
            case 'log':
            case 'csv':
                icon = '<i class="far' + (fixed_width ? ' fa-fw' : '') + ' fa-file-alt"></i>';
                break;
            case 'png':
            case 'gif':
            case 'jpg':
            case 'jpeg':
                icon = '<i class="far' + (fixed_width ? ' fa-fw' : '') + ' fa-file-image"></i>';
                break;
            case 'mp4':
            case 'mov':
            case 'webm':
                icon = '<i class="far' + (fixed_width ? ' fa-fw' : '') + ' fa-film-alt"></i>';
                break;
            default:
                icon = '<i class="far' + (fixed_width ? ' fa-fw' : '') + ' fa-paperclip"></i>';
                break;
        }

        return icon;

    },

    transitionEnd: function(element, event_handler, context) {
        var support_transition = false;
        var transition_names   = ['transition', 'WebkitTransition', 'MozTransition', 'msTransition'];
        var temp_element       = document.createElement('div');

        $(transition_names).each(function(index, transition_name) {
            if (temp_element.style[transition_name] !== undefined) {
                support_transition = true;
                return false;
            }
        });

        context = context || this;

        if (support_transition) {
            var event_names = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';

            element.bind(event_names, function (event) {
                element.unbind(event_names);
                event_handler.call(context, event, element);
            });
        } else {
            setTimeout(function() {
                event_handler.call(context, null, element);
            }, 0);
        }

        // return element so that we can chain methods
        return element;
    },

    animationEnd: function(element, event_handler, context) {
        var support_transition = false;
        var transition_names   = ['animation', 'WebkitAnimation', 'MozAnimation', 'msAnimation'];
        var temp_element       = document.createElement('div');

        $(transition_names).each(function(index, transition_name) {
            if (temp_element.style[transition_name] !== undefined) {
                support_transition = true;
                return false;
            }
        });

        context = context || this;

        if (support_transition) {
            var event_names = 'webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend';

            element.bind(event_names, function (event) {
                element.unbind(event_names);
                event_handler.call(context, event, element);
            });
        } else {
            setTimeout(function() {
                event_handler.call(context, null, element);
            }, 0);
        }

        // return element so that we can chain methods
        return element;
    },

    moment: function(unix_timestamp, format, timezone, from_now, default_value, prefix) {
        if (!unix_timestamp || unix_timestamp <= 0) {
            if (default_value) {
                return default_value;
            } else {
                return '';
            }
        }

        if (from_now === undefined) {
            from_now = true;
        }

        if (!timezone) {
            if (Cache.account && Cache.account.get('timezone')) {
                timezone = Cache.account.get('timezone');
            } else {
                timezone = Config.default_timezone;
            }
        }

        var moment = Moment.unix(unix_timestamp);
        var now    = new Moment();

        format = format || 'DD MMM YYYY';

        if (!from_now || now.diff(moment, 'days') >= 1) {
            if (prefix) {
                return prefix + ' ' + Moment.tz(unix_timestamp * 1000, timezone).format(format);
            } else {
                return Moment.tz(unix_timestamp * 1000, timezone).format(format);
            }
        } else {
            return moment.fromNow(true);
        }
    },
    // Get tomorrow 8am with format in the specified timezone
    getTomorrow: function(format, timezone, time = '08:00:00') {
        if (!timezone) {
            if (Cache.account && Cache.account.get('timezone')) {
                timezone = Cache.account.get('timezone');
            } else {
                timezone = Config.default_timezone;
            }
        }

        // Get the current moment in the specified timezone
        let now = Moment().tz(timezone);

        const milliseconds = Util.timeToMilliseconds(time) || Util.timeToMilliseconds('08:00:00');

        // Get tomorrow at 08:00 AM
        let tomorrow = now.add(1, 'days').startOf('day').add(milliseconds, 'milliseconds');

        return tomorrow.format(format); // Formatted output
    },
    // Get next Monday 8am with format in the specified timezone
    getNextMonday: function(format, timezone, time = '08:00:00') {
        if (!timezone) {
            if (Cache.account && Cache.account.get('timezone')) {
                timezone = Cache.account.get('timezone');
            } else {
                timezone = Config.default_timezone;
            }
        }

        // Get the current moment in the specified timezone
        let now = Moment().tz(timezone);

        const milliseconds = Util.timeToMilliseconds(time) || Util.timeToMilliseconds('08:00:00');

        // Calculate the days until next Monday
        let daysUntilMonday = (8 - now.isoWeekday()) % 7 || 7; // Ensures Monday is always in the future

        // Get next Monday at 08:00 AM
        let nextMonday = now.add(daysUntilMonday, 'days').startOf('day').add(milliseconds, 'milliseconds');

        return nextMonday.format(format); // Formatted output
    },

    momentFromNow: function(unix_timestamp, timezone) {
        if (!unix_timestamp || unix_timestamp <= 0) {
            return '';
        }

        if (!timezone) {
            if (Cache.account && Cache.account.get('timezone')) {
                timezone = Cache.account.get('timezone');
            } else {
                timezone = Config.default_timezone;
            }
        }

        var moment = Moment.unix(unix_timestamp);

        return moment.fromNow(true);
    },

    isSameDay: function(unix_timestap1, unix_timestamp2) {
        var moment1 = Moment.unix(unix_timestap1);
        var moment2 = Moment.unix(unix_timestamp2);

        return moment1.isSame(moment2, 'day');
    },

    startOfDay: function(unix_timestamp) {
        var moment = Moment.unix(unix_timestamp);

        return moment.startOf('day').unix();
    },

    daysDiff: function(unix_timestamp) {
        var moment = Moment.unix(unix_timestamp);
        var now    = new Moment();

        return now.diff(moment, 'days');
    },

    secondsDiff: function(unix_timestamp) {
        var moment = Moment.unix(unix_timestamp);
        var now    = new Moment();

        return now.diff(moment, 'seconds');
    },

    timeToMilliseconds: function (time_string) {
        var parts = time_string.split(':');

        // If the time string is in the h:mm:ss format
        if (parts.length === 3) {
            var hours = parseInt(parts[0], 10);
            var minutes = parseInt(parts[1], 10);
            var seconds = parseInt(parts[2], 10);

          return ((hours * 60 * 60) + (minutes * 60) + seconds) * 1000;
        } else if (parts.length === 2) {
            // If the time string is in the mm:ss format
            var minutes = parseInt(parts[0], 10);
            var seconds = parseInt(parts[1], 10);

            return ((minutes * 60) + seconds) * 1000;
        } else {
            // If the time string is not in an expected format
            return false;
        }
    },

    now: function() {
        return Moment();
    },

    nowUnix: function(timezone) {
        if (!timezone) {
            if (Cache.account && Cache.account.get('timezone')) {
                timezone = Cache.account.get('timezone');
            } else {
                timezone = Config.default_timezone;
            }
        }

        return Moment.tz(timezone).unix();
    },

    dateStringToTimestamp: function(str, format, timezone) {
        if (!timezone) {
            if (Cache.account && Cache.account.get('timezone')) {
                timezone = Cache.account.get('timezone');
            } else {
                timezone = Config.default_timezone;
            }
        }

        return Moment.tz(str, format, timezone).unix();
    },

    translateMonth: function(month, short) {
        if (short) {
            return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][month];
        } else {
            return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'Augest', 'September', 'October', 'November', 'December'][month];
        }
    },

    isNumeric: function(data) {
        return data == parseInt(data, 10);
    },

    isAlphanumeric: function(string) {
        return /^[a-zA-Z0-9]+$/i.test(string);
    },

    isValidEmail: function(email) {
        var regex = /\S+@\S+\.\S+/;
        return regex.test(email);
    },

    isValidHex: function(hex) {
        var is_valid = false;

        if (hex.length == 7 && hex.match(/^#([0-9a-f]{3}){1,2}$/i)) {
            is_valid = true;
        }

        return is_valid;
    },

    hexToRgba: function(hex, opacity, use_rgb) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

        if (!result) {
            return null;
        }

        var r = parseInt(result[1], 16);
        var g = parseInt(result[2], 16);
        var b = parseInt(result[3], 16);

        if (use_rgb) {
            r = r * opacity + 255 * (1 - opacity);
            g = g * opacity + 255 * (1 - opacity);
            b = b * opacity + 255 * (1 - opacity);

            return 'rgb(' + r + ', ' + g + ', ' + b + ')';
        } else {
            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity + ')';
        }
    },

    arrayUnique(array) {
        var unique_copy = [];

        array.forEach(function(item) {
            if (unique_copy.indexOf(item) === -1) {
                unique_copy.push(item);
            }
        });

        return unique_copy;
    },

    trim: function(text, length, ellipsis) {
        if (typeof ellipsis === 'undefined') {
            ellipsis = '...';
        }

        if (text.length > length) {
            text = text.substring(0, length) + ellipsis;
        }

        return text;
    },

    getCharColour: function(char) {
        var colour = ['05668D', 'F2B5D4', 'F6BD60', 'F5CAC3', '84A59D', 'F28482', '90BE6D', 'FF6F71', '9B5DE5', 'A5A58D', 'FCBF49', '9D8189', 'B8BEDD'];
        var background_options = {
            a: colour[0],
            b: colour[1],
            c: colour[2],
            d: colour[3],
            e: colour[4],
            f: colour[5],
            g: colour[6],
            h: colour[7],
            i: colour[8],
            j: colour[9],
            k: colour[10],
            l: colour[11],
            m: colour[12],
            n: colour[0],
            o: colour[1],
            p: colour[2],
            q: colour[3],
            r: colour[4],
            s: colour[5],
            t: colour[6],
            u: colour[7],
            v: colour[8],
            w: colour[9],
            x: colour[10],
            y: colour[11],
            z: colour[12],
            0: colour[0],
            1: colour[1],
            2: colour[2],
            3: colour[3],
            4: colour[4],
            5: colour[5],
            6: colour[6],
            7: colour[7],
            8: colour[8],
            9: colour[9]
        };

        return '#' + background_options[char.toLowerCase()];
    },

    gravatar: function(email, size, name) {
        email = email || '';
        size  = size || 32;
        size  = size * 2; // retina

        // temp fix
        if (size === 48) {
            size = 64;
        }

        if (!name) {
            name = email;
        }

        var colour = ['05668D', 'F2B5D4', 'F6BD60', 'F5CAC3', '84A59D', 'F28482', '90BE6D', 'FF6F71', '9B5DE5', 'A5A58D', 'FCBF49', '9D8189', 'B8BEDD'];

        var rounded    = 'false';
        var uppercase  = 'true';
        var bold       = 'false';
        var background = Util.getCharColour(name.charAt(0)).replace('#', '');
        var colour     = 'FFFFFF';
        var length     = 2;

        if (!background) {
            background = 'DDDDDD';
        }

        if (!name) {
            return '/image/profile.png';
        }

        var d = encodeURIComponent('https://ui-avatars.com/api/' + name.replace(/[^a-z]/gi, '') + '/' + size + '/' + background + '/' + colour + '/' + length + '/0.5/' + rounded + '/' + uppercase + '/' + bold + '/png');

        var url = 'https://www.gravatar.com/avatar/';
        url += md5(email.trim().toLowerCase());
        url += '?s=' + size + '&d=' + d;

        return url;
    },

    padLeft: function(string, zero) {
        string = string + '';
        zero = zero || '000000';

        return zero.substring(0, zero.length - string.length) + string;
    },

    uploadImages: function(num, size_limit, callback) {
        var file_input = $('<input type="file" accept="image/png, image/jpeg, image/gif, image/svg+xml"' + (num > 1 ? ' multiple' : '') + '>').hide();

        file_input.on('change', function(e) {
            var files = e.target.files || e.dataTransfer.files;

            if (files.length > num) {
                UI.error('Please select up to ' + num + ' images at a time');
                return;
            }

            var response = [];
            var count = 0;
            for (var i = 0; i < files.length; i++) {
                var result = Util.readFile(files[i], size_limit, function(file_name, file_type, file_content) {
                    var image = new Image();
                    image.onload = function() {
                        count++;

                        response.push({
                            name    : file_name,
                            type    : file_type,
                            content : file_content,
                            width   : image.width,
                            height  : image.height
                        });

                        if (count === files.length) {
                            callback(response);
                        }
                    };
                    image.onerror = function() {
                        count++;

                        response.push({
                            error: 'Image couldn\'t be loaded'
                        });

                        if (count === files.length) {
                            callback(response);
                        }
                    };
                    image.src = file_content;
                });

                if (result !== true) {
                    response.push({
                        error: result
                    });

                    count++;
                    if (count === files.length) {
                        callback(response);
                    }
                }
            }
        });

        file_input.click();
    },

    uploadFile: function(size_limit, callback, file_type) {
        var file_input = $('<input type="file"' + (file_type ? ' accept="' + file_type.join(', ') + '"' : '') + '>').hide();

        file_input.on('change', (e) => {
            var result = Util.readFile(e.target.files[0], size_limit, (file_name, file_type, file_result) => {
                callback('', file_name, file_type, file_result);
            });

            if (result !== true) {
                callback(result);
            }
        });

        file_input.click();
    },

    readFile: function(file_field, file_size, onLoad) {
        var file       = file_field;
        var reader     = new FileReader();
        var size_limit = file_size || 1; // file size limit: 1MB
        var extension  = this.fileExtension(file.name);

        if (!extension || Constants.FILE_BLOCK_LIST.indexOf(extension.toLowerCase()) !== -1) {
            return 'File format not supported';
        }

        if (file.size > size_limit * 1024 * 1024) {
            return 'File size must be smaller than ' + size_limit + 'MB';
        }

        reader.onloadend = function() {
            onLoad(file.name, file.type, reader.result);
        };

        reader.readAsDataURL(file);

        return true;
    },

    readImage: function(file_field, file_size, onLoad) {
        var file       = file_field;
        var reader     = new FileReader();
        var size_limit = file_size || 1; // file size limit: 1MB\

        if (!file.type.match(/^image\/(jpeg|png|gif|svg)/)) {
            return 'Please select a .png, .jpg, .gif or .svg file';
        }

        if (file.size > size_limit * 1024 * 1024) {
            return 'Image size must be smaller than ' + size_limit + 'MB';
        }

        reader.onloadend = function() {
            onLoad(file.name, file.type, reader.result);
        };

        reader.readAsDataURL(file);

        return true;
    },

    blobTodataURI: function(blob, callback) {
        var mycanvas = document.createElement('canvas');
        var ctx = mycanvas.getContext('2d');
        var img = new Image();
        img.onload = () => {
            mycanvas.width = img.width;
            mycanvas.height = img.height;

            ctx.drawImage(img, 0, 0);

            callback({
                data_uri: mycanvas.toDataURL(),
                width: img.width,
                height: img.height
            });
        };

        try {
            img.src = URL.createObjectURL(blob);
        } catch(e) {
            // error
        }
    },

    dataURItoBlob: function(data_uri) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(data_uri.split(',')[1]);

        // separate out the mime component
        var mimeString = data_uri.split(',')[0].split(':')[1].split(';')[0]

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);

        // create a view into the buffer
        var ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        var blob = new Blob([ab], {type: mimeString});
        return blob;
    },

    getCreditCardType: function(number) {
        // visa
        var re = new RegExp("^4");

        if (number.match(re) != null) {
            return "Visa";
        }

        // Mastercard
        // Updated for Mastercard 2017 BINs expansion
        re = new RegExp("^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$");

        //if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) {
        if (number.match(re) != null) {
            return "Mastercard";
        }

        // AMEX
        re = new RegExp("^3[47]");
        if (number.match(re) != null) {
            return "AMEX";
        }

        // Discover
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if (number.match(re) != null) {
            return "Discover";
        }

        // Diners
        re = new RegExp("^36");
        if (number.match(re) != null) {
            return "Diners";
        }

        // Diners - Carte Blanche
        re = new RegExp("^30[0-5]");
        if (number.match(re) != null) {
            return "Diners - Carte Blanche";
        }

        // JCB
        re = new RegExp("^35(2[89]|[3-8][0-9])");
        if (number.match(re) != null) {
            return "JCB";
        }

        // Visa Electron
        re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        if (number.match(re) != null) {
            return "Visa Electron";
        }

        return "";
    },

    shuffleArray: function(array) {
        for (let i = array.length - 1; i > 0; i--) {
            // Generate a random index between 0 and i (inclusive)
            const j = Math.floor(Math.random() * (i + 1));

            // Swap elements array[i] and array[j]
            [array[i], array[j]] = [array[j], array[i]];
        }

        return array;
    },

    markdownToHtml: function (markdown) {
        markdown = markdown.replace(/\\\n/g, '\n');
        // Escape HTML
        markdown = markdown.replace(/</g, '&lt;').replace(/>/g, '&gt;');

        // Code blocks: ```code```
        const codeBlocks = [];

        // extract ```code```, and store in placeholder
        markdown = markdown.replace(/```\s*([\s\S]*?)```/g, (_, code) => {
            codeBlocks.push(`<pre><code>${code}</code></pre>`);
            return `@@CODEBLOCK${codeBlocks.length - 1}@@`;
        });

        // Inline code
        markdown = markdown.replace(/`([^`\n]+)`/g, '<code>$1</code>');

        // Headings
        markdown = markdown.replace(/^\s*## (.*)$/gm, '<h2>$1</h2>');

        // Bold and Italic
        markdown = markdown.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        markdown = markdown.replace(/__(.*?)__/g, '<strong>$1</strong>');
        markdown = markdown.replace(/\*(.*?)\*/g, '<em>$1</em>');
        markdown = markdown.replace(/_(.*?)_/g, '<em>$1</em>');

        // Links
        markdown = markdown.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>');

        // Ordered Lists
        markdown = markdown.replace(/(^\d+\..+(?:\n\d+\..+)*)/gm, function (match) {
            const items = match.trim().split('\n').map(item =>
            `<li>${item.replace(/^\d+\.\s*/, '')}</li>`).join('');
            return `<ol>${items}</ol>`;
        });

        // Unordered Lists
        markdown = markdown.replace(/(^[-*].+(?:\n[-*].+)*)/gm, function (match) {
            const items = match.trim().split('\n').map(item =>
            `<li>${item.replace(/^[-*]\s*/, '')}</li>`).join('');
            return `<ul>${items}</ul>`;
        });

        // Paragraphs (skip lines starting with known block tags)
        markdown = markdown.replace(/^(?!<(h\d|ul|ol|li|pre|blockquote|p|\/)).+$/gm, '<p>$&</p>');

        // Add <br> only inside <p>...</p>
        markdown = markdown.replace(/<p>(.*?)<\/p>/gs, (match, content) => {
            const withBr = content.replace(/\n/g, '<br>\n');
            return `<p>${withBr}</p>`;
        });


        // restore code blocks
        markdown = markdown.replace(/@@CODEBLOCK(\d+)@@/g, (_, index) => codeBlocks[index]);

        return markdown.trim();
    }
};

export default Util;
